[
  {
    "id": 1,
    "name": "Germany",
    "label": "dd.mm.yyyy",
    "shortFormat": "dd.MM.",
    "longFormat": "dd.MM.yyyy",
    "shuiFormat": "DDMMYYYY",
    "shuiLocale": "de",
    "shuiSeparator": "."
  },
  {
    "id": 2,
    "name": "United Kingdom",
    "label": "dd/mm/yyyy",
    "shortFormat": "dd/MM",
    "longFormat": "dd/MM/yyyy",
    "shuiFormat": "DDMMYYYY",
    "shuiLocale": "en",
    "shuiSeparator": "/"
  },
  {
    "id": 3,
    "name": "United States",
    "label": "mm/dd/yyyy",
    "shortFormat": "MM/dd",
    "longFormat": "MM/dd/yyyy",
    "shuiFormat": "MMDDYYYY",
    "shuiLocale": "en",
    "shuiSeparator": "/"
  },
  {
    "id": 4,
    "name": "ISO 8601",
    "label": "yyyy-mm-dd",
    "shortFormat": "MM-dd",
    "longFormat": "yyyy-MM-dd",
    "shuiFormat": "YYYYMMDD",
    "shuiLocale": "en",
    "shuiSeparator": "-"
  }
]
